import { useState } from "react";
import api from "../api/axios";
import { saveAuth } from "../auth/auth";
import { useNavigate, Link } from "react-router-dom";
import AlertBox from "../components/AlertBox";
import { useTranslation } from "react-i18next"; // <-- استدعاء الترجمة

export default function Register() {
    const { t } = useTranslation(); // <-- تفعيل الترجمة

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);
    const nav = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setErr("");

        if (password !== password2) {
            setErr(t("passwords_mismatch")); // <-- ترجمة رسالة الخطأ
            return;
        }

        setLoading(true);

        try {
            const res = await api.post("/register", { name, email, password });
            const payload = res.data.data ?? res.data;
            saveAuth(payload);
            nav("/");
        } catch (e) {
            const data = e.response?.data;
            if (data?.errors) {
                const firstKey = Object.keys(data.errors)[0];
                setErr(data.errors[firstKey][0]);
            } else {
                setErr(t("register_failed")); // <-- ترجمة رسالة الخطأ
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container my-3">
            <div className="row border shadow-sm bg-white">
                {/* العمود الأيسر: الصور من القالب الجديد */}
                <div className="col-md-6 bg-light bg-gradient p-3 d-none d-md-block border-end">
                    <Link to="/">
                        <img src="../../images/banner/Dell.webp" alt="Dell Banner" className="img-fluid mb-3" onError={(e) => e.target.style.display = 'none'} />
                    </Link>
                    <Link to="/">
                        <img src="../../images/banner/Laptops.webp" alt="Laptops Banner" className="img-fluid" onError={(e) => e.target.style.display = 'none'} />
                    </Link>
                    <div className="text-center py-5 mt-5">
                        <i className="bi bi-person-plus display-1 text-muted opacity-25"></i>
                        <h4 className="text-muted mt-3">{t("join_family")}</h4>
                    </div>
                </div>

                {/* العمود الأيمن: الفورم */}
                <div className="col-md-6 p-4">
                    <h4 className="text-center mb-4 fw-bold">{t("register_title")}</h4>

                    <AlertBox type="danger" message={err} onClose={() => setErr("")} />

                    <form onSubmit={submit}>
                        <div className="mb-3">
                            <label className="form-label small fw-bold">{t("fullname_label")}</label>
                            <input type="text" className="form-control" placeholder={t("fullname_placeholder")} value={name} onChange={(e) => setName(e.target.value)} required />
                        </div>

                        <div className="mb-3">
                            <label className="form-label small fw-bold">{t("email_label")}</label>
                            <input type="email" className="form-control" placeholder="example@mail.com" value={email} onChange={(e) => setEmail(e.target.value)} required />
                        </div>

                        <div className="mb-3">
                            <label className="form-label small fw-bold">{t("password_label")}</label>
                            <input type="password" className="form-control" placeholder={t("password_placeholder")} value={password} onChange={(e) => setPassword(e.target.value)} required />
                        </div>

                        <div className="mb-4">
                            <label className="form-label small fw-bold">{t("confirm_password_label")}</label>
                            <input type="password" className="form-control" placeholder={t("confirm_password_placeholder")} value={password2} onChange={(e) => setPassword2(e.target.value)} required />
                        </div>

                        <button className="btn btn-primary w-100 fw-bold py-2" disabled={loading}>
                            {loading ? <span className="spinner-border spinner-border-sm"></span> : t("create_new_account")}
                        </button>
                    </form>

                    <div className="text-center mt-4">
                        <p className="small text-muted">
                            {t("have_account")} <Link to="/login" className="fw-bold text-decoration-none">{t("login_title")}</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}